export const numFormat = {
  methods: {
    commafy(num) {
      if ((num + "").trim() == "") {
        return "";
      }
      if (isNaN(num)) {
        return "";
      }
      num = num + "";
      let re;
      if (/^.*\..*$/.test(num)) {
        let pointIndex = num.lastIndexOf(".");
        let intPart = num.substring(0, pointIndex);
        let pointPart = num.substring(pointIndex + 1, num.length);
        intPart = intPart + "";
        re = /(-?\d+)(\d{3})/
        while (re.test(intPart)) {
          intPart = intPart.replace(re, "$1,$2")
        }
        num = intPart + "." + pointPart;
      } else {
        num = num + "";
        re = /(-?\d+)(\d{3})/
        while (re.test(num)) {
          num = num.replace(re, "$1,$2")
        }
      }
      return num;
    }
  }
}